module.exports = __webpack_public_path__ + "static/media/b1_p11_clickable_b.6c974f50.mp3";